// extracted by mini-css-extract-plugin
export default {"phone-number-card":"phone-number-card_NyV6R"};